import React, { useState, memo } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
const FaqItem = ({
  question,
  answer
}: {
  question: string;
  answer: React.ReactNode;
}) => {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-b border-gray-200 py-4" data-id="element-47">
      <button className="flex justify-between items-center w-full text-left font-nunito font-bold text-lg text-brand-charcoal hover:text-brand-teal transition-colors" onClick={() => setIsOpen(!isOpen)} data-id="element-48">
        <span className="pr-4" data-id="element-49">{question}</span>
        {isOpen ? <ChevronUp className="w-5 h-5 flex-shrink-0 text-brand-teal" data-id="element-50" /> : <ChevronDown className="w-5 h-5 flex-shrink-0 text-gray-400" data-id="element-51" />}
      </button>
      {isOpen && <div className="mt-4 text-gray-600 font-inter leading-relaxed text-base md:text-lg" data-id="element-52">
          {answer}
        </div>}
    </div>;
};
export const FAQ = () => {
  const faqs = [{
    q: '¿Cuándo y cómo recibo la guía?',
    a: <>
          Es un <strong data-id="element-53">producto digital</strong>. Apenas completás el pago,
          recibís <em data-id="element-54">acceso inmediato por email</em>. Podés leerlo desde tu
          celular, tablet o computadora en minutos.
        </>
  }, {
    q: '¿Para qué edades aplica?',
    a: <>
          La guía está pensada principalmente para{' '}
          <strong data-id="element-55">niños de 2 a 7 años</strong>, pero los principios de
          neurología del tránsito y manejo del miedo aplican a edades más
          amplias. Si tu hijo tiene más de 7 años,{' '}
          <em data-id="element-56">igual vas a encontrar información muy valiosa</em>.
        </>
  }, {
    q: 'Ya probé todo. ¿Por qué esto va a ser diferente?',
    a: <>
          Porque lo que probaste ataca los síntomas. Esta guía trabaja la{' '}
          <strong data-id="element-57">causa real</strong>: la memoria de dolor y el ciclo
          miedo-retención. Es un enfoque{' '}
          <span className="underline decoration-gray-300 decoration-2 underline-offset-2" data-id="element-58">
            completamente diferente
          </span>{' '}
          y por eso funciona cuando lo demás falló.
        </>
  }, {
    q: '¿Reemplaza la consulta con el pediatra?',
    a: <>
          <strong data-id="element-59">No.</strong> Esta guía es un complemento poderoso, pero si tu
          hijo tiene síntomas severos o una condición médica diagnosticada,{' '}
          <em data-id="element-60">siempre consultá con su médico</em>. Lo que hace esta guía es
          darte el conocimiento para entender lo que pasa y las herramientas
          para <strong data-id="element-61">actuar en casa con confianza</strong>.
        </>
  }, {
    q: '¿Cómo funciona la garantía?',
    a: <>
          Simple: si en 7 días no estás satisfecha por cualquier motivo,
          escribime y <strong data-id="element-62">te devuelvo el 100% de tu dinero</strong>.{' '}
          <em data-id="element-63">Sin preguntas, sin formularios complicados, sin letra chica.</em>{' '}
          Mi reputación vale más que cualquier venta.
        </>
  }, {
    q: '¿Por qué el precio es tan bajo? ¿Hay algo que no estás diciendo?',
    a: <>
          Porque es un lanzamiento y quiero que esta información llegue a la
          mayor cantidad de mamás posible. Una vez que tenga más testimonios y
          cierre esta etapa, <strong data-id="element-64">el precio va a subir</strong>. Esta es la{' '}
          <span className="underline decoration-gray-300 decoration-2 underline-offset-2" data-id="element-65">
            oportunidad de entrar al precio de lanzamiento
          </span>
          .
        </>
  }];
  return <section className="py-10 md:py-20 px-4 bg-white" data-id="element-66">
      <div className="max-w-3xl mx-auto" data-id="element-67">
        <h2 className="font-nunito font-extrabold text-3xl md:text-4xl text-center text-brand-charcoal mb-8" data-id="element-68">
          Preguntas Frecuentes
        </h2>
        <div className="space-y-2" data-id="element-69">
          {faqs.map((faq, index) => <FaqItem key={index} question={faq.q} answer={faq.a} data-id="element-70" />)}
        </div>
      </div>
    </section>;
};